import React, { useState } from 'react';
import Dropdown from '../../../../Global/Dropdown';
import ConfigCard from '../../blocks/ConfigCard';
import { GetBrandedAppName, GetBrandedCompanyName } from '../../../../../services/BrandingService';

// currently a static list of available custom ARM level mappings
const availableCustomARMLevelMappings = [
  { value: 'none', label: 'None' },
  { value: 'spire', label: 'EPS S.P.I.R.E.' }
];

export default function SelectCustomARMLevelMapping(props) {
  
  const { selectedCustomARMLevelMapping, setSelectedCustomARMLevelMapping } = props;

  const updateSetting = (e) => {
    if(e.value === 'none') {
      setSelectedCustomARMLevelMapping(null);
    }
    setSelectedCustomARMLevelMapping(e.value);
  }

  // Hardcoded to only show for EPS branded accounts, this will change in the future.
  // if the company name is not EPS and there is no selected custom ARM level mapping, return null
  if(GetBrandedCompanyName() !== 'EPS' && (!selectedCustomARMLevelMapping || selectedCustomARMLevelMapping === 'none')) return null;

  if(!availableCustomARMLevelMappings.length) return null;

  return (
    <ConfigCard title='Show Placement' description={`${GetBrandedAppName()} will recommend a placement into the selected curriculum based on a student's ARM score.`}>
      <div className='configure-scales-reporting-row'>
        <div className='configure-reporting-dropdown'>
          <label>Choose a Curriculum</label>
          <Dropdown
            options={availableCustomARMLevelMappings}
            value={selectedCustomARMLevelMapping ? availableCustomARMLevelMappings.find(option => option.value === selectedCustomARMLevelMapping) : availableCustomARMLevelMappings[0]}
            onChange={(e) => updateSetting(e)}
            isDisabled={false}
          />
        </div>
      </div>
    </ConfigCard>
  )
}